import { FC } from "react";
import { pluralize } from "@common/helpers/string";
import { CommandsListProps } from "./lib";
import { TaskBulkOptionsCommandsList } from "./TaskBulkOptionsCommandsList";

export const TaskBulkStatusCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { selectedTaskCount = 0, taskBulkStatusOptions = [] } = options;

    return (
        <TaskBulkOptionsCommandsList
            heading={`Set status for ${selectedTaskCount} ${pluralize("task", selectedTaskCount)}`}
            options={taskBulkStatusOptions}
        />
    );
};
